import { Component } from "@angular/core";
import moment from "moment-timezone";
import { ConfirmationService } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOOrderType } from "src/app/shared/models/oo-order-type";

@Component({
	selector: "app-order-type-setup",
	templateUrl: "./order-type-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class OrderTypeSetupComponent {
	changesToSave: boolean = false;
	displayOrderTypeUi: boolean = false;

	orderType: OOOrderType;

	loaded: boolean = false;

	moment: any = moment;

	newRecord: boolean = false;

	orderTypeIndex: number = undefined;
	orderTypeIdSelected: number = undefined;

	timestamp;
	timezones: any[] = [];

	constructor(public app: AppService, public imgCrop: ImageCropperService, public venueSvc: OOVenueService, private confirm: ConfirmationService) {}

	async orderTypeAdd() {
		this.newRecord = true;
		this.orderType = new OOOrderType({
			venueKey: this.venueSvc.venueKey,
		});
		this.venueSvc.ooOrderTypes.push(this.orderType);
	}

	async orderTypeDelete(recKey: number) {
		this.confirm.confirm({
			message: `Are you sure you want to delete this order type? This action cannot be undone.`,
			accept: async () => {
				this.venueSvc.ooOrderTypeDelete(this.venueSvc.ooOrderTypes.find((i) => i.key === recKey));
			},
			reject: async () => {
				this.confirm.close();
			},
		});
	}

	orderTypeSelect(otRecord: OOOrderType) {
		this.orderTypeIdSelected = otRecord.key;
		this.orderTypeIndex = this.venueSvc.ooOrderTypes.findIndex((i) => i.key === otRecord.key);
	}
}
